import React, { useState } from 'react'
import { Form } from 'react-bootstrap'
import { buildRuleStructure, isValidRegex } from '../../../utils/rules'
import { updateCustomRule } from '../../api_methods'
import { extractData, notify } from '../../../utils/index_tagging_tool'


export function RuleRow({ rule, tagWidth= 200, regexWidth= 300, editRegex = true, editTag = false }) {
  /**
   * Rule visualizer component, used to show and eventually edit the tag and the regex of a rule
   */
  const [containsRegex, setContainsRegex] = useState(rule.pos_regex !== '~' ? rule.pos_regex : '');
  const [containsRegexErrors, setContainsRegexErrors] = useState(false);

  const [notContainsRegex, setNotContainsRegex] = useState(rule.neg_regex !== '~' ? rule.neg_regex : '');
  const [notContainsRegexErrors, setNotContainsRegexErrors] = useState(false);

    // Aggiornamento della regola, che viene salvata o creata (il salvataggio/creazione è usato da altre funzioni)
  const updateRule = () => {
    if (containsRegexErrors || notContainsRegexErrors)
      return
    // formato standard a tutte le regole SEO
    const newRule = buildRuleStructure(rule, rule.tag_it, rule.tag_en, containsRegex, notContainsRegex)

    updateCustomRule(newRule.id, newRule).then(extractData)
      .then((data) => {
        console.log(data)
      })
      .catch((e) => {
        notify('La comunicazione con il server è stata interrotta', 'error')
      })
  }

  const handleContains = (event) => {
    setContainsRegex(event.target.value)
    if (isValidRegex(event.target.value))
      setContainsRegexErrors(false)
    else
      setContainsRegexErrors(true)
  }

  const handleNotContains = (event) => {
    setNotContainsRegex(event.target.value)
    if (isValidRegex(event.target.value))
      setNotContainsRegexErrors(false)
    else
      setNotContainsRegexErrors(true)
  }

  return (
    <div
      className="d-flex align-items-center pb-3"
    >
      <div style={{ width: `${tagWidth}px` }}>
        <fieldset className="w-seo-control-field">
          <Form.Control
            type="text"
            title={rule.tag_it}
            value={rule.tag_it}
            disabled={!editTag}
            className="form-control font-weight-bold"
            placeholder="Tag"
            onChange={() => {}}
            onBlur={() => {}}
          />
        </fieldset>
      </div>
      <div style={{ width: `${regexWidth}px` }}>
        <fieldset className="w-seo-control-field">
          <Form.Control
            type="text"
            title={containsRegex}
            value={containsRegex}
            isInvalid={containsRegexErrors}
            disabled={!editRegex}
            className="form-control"
            placeholder="Contiene"
            onChange={handleContains}
            onBlur={updateRule}
          />
        </fieldset>
      </div>
      <div style={{ width: `${regexWidth}px` }}>
        <fieldset className="w-seo-control-field">
          <Form.Control
            type="text"
            title={notContainsRegex}
            value={notContainsRegex}
            isInvalid={notContainsRegexErrors}
            disabled={!editRegex}
            className="form-control"
            placeholder="Non Contiene"
            onChange={handleNotContains}
            onBlur={updateRule}
          />
        </fieldset>
      </div>
    </div>
  )
}